import { Component } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavService } from '../../services/nav.service';
import { LoginService } from '../../services/login.service';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent {

  isFromLogin: boolean = false
  isEnvironmentDevelopment: boolean = environment.development ? true : false

  constructor(
    public layout: LayoutService, 
    private route: ActivatedRoute, 
    public navServices: NavService,
    private router: Router, 
    private authService: LoginService) {

    if(this.route.snapshot.routeConfig?.path?.includes('from-login')) {
      this.isFromLogin = true
    }
  }

  save() {
    let userData = JSON.parse(localStorage.getItem('user')!)

    let model = {
      full_name: userData.user.full_name,
      full_name_latin: userData.user.full_name_latin,
      country_id: userData.user.country_id,
      address: userData.guardian.address,
      accept_terms_flag: "1",
    }
    
    this.authService.updateParent(model).subscribe(res => {
      localStorage.removeItem('user')
      this.router.navigate(['/auth/login'])
    })
  }


  get layoutClass() {
    switch(this.layout.config.settings.layout){
      case "Dubai":
        return "compact-wrapper"
      case "London":
        return "only-body"
      case "Seoul":
        return "compact-wrapper modern-type"
      case "LosAngeles":
        return this.navServices.horizontal ? "horizontal-wrapper material-type" : "compact-wrapper material-type"
      case "Paris":
        return "compact-wrapper dark-sidebar"
      case "Tokyo":
        return "compact-sidebar"
      case "Madrid":
        return "compact-wrapper color-sidebar"
      case "Moscow":
        return "compact-sidebar compact-small"
      case "NewYork":
        return "compact-wrapper box-layout"
      case "Singapore":
        return this.navServices.horizontal ? "horizontal-wrapper enterprice-type" : "compact-wrapper enterprice-type"
      case "Rome":
        return "compact-sidebar compact-small material-icon"
      case "Barcelona":
        return this.navServices.horizontal ? "horizontal-wrapper enterprice-type advance-layout" : "compact-wrapper enterprice-type advance-layout"
      case "horizontal-wrapper":
        return this.navServices.horizontal ? "horizontal-wrapper" : "compact-wrapper"
      default:
        return "compact-wrapper"
    }
  }

}
